import { Button, Divider, Modal, Radio, Typography, message } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  arciveDiaries,
  saveAllArchiveDiaries,
  saveCurrentDiary,
  saveDiaryStatus,
  saveNewlyCreatedDiary,
  saveUnArchiveModalOpen,
} from "redux/diaries/diariesSlice";
import { useDispatch, useSelector } from "react-redux";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
const { Title } = Typography;

export default function ArchiveRequest({ isArchiveRequestModalOpen }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const diaries = useSelector(arciveDiaries);
  const [btnLoading, setbtnLoading] = useState(false);
  const close = () => {
    dispatch(saveUnArchiveModalOpen({ flag: false, diaryId: null, name: "" }));
  };
  const unarchiveRequest = async () => {
    try {
      setbtnLoading(true);
      const body = {
        diaryId: isArchiveRequestModalOpen?.diaryId,
        action: 2,
        archiveReason: null,
      };
      const res = await NetworkCall.fetch(
        Request.archiveUnArchiveJournal(body)
      );
      message.success(res?.message);
      let temp = [...diaries];
      const index = temp?.findIndex(
        (e) => e?.diaryId === isArchiveRequestModalOpen?.diaryId
      );
      temp[index] = {
        ...temp[index],
        isArchiveOrUnarchiveRequester: true,
        status: {
          ...temp[index]?.status,
          id: 7,
          name: "PendingToUnarchive",
        },
      };
      dispatch(saveDiaryStatus({ diary: temp[index] }));
      const x = temp.splice(index, 1);
      dispatch(saveNewlyCreatedDiary(x[0]));
      dispatch(saveAllArchiveDiaries(temp));
      close();
      setbtnLoading(false);
      const params = `?archived=true`;
      navigate(`/journal-request${params}`);
      dispatch(saveDiaryStatus({}));
      dispatch(saveCurrentDiary({}));
    } catch (error) {
      setbtnLoading(false);
    }
  };
  return (
    <Modal
      className="create-diary-modal archive-req-modal"
      centered
      open={isArchiveRequestModalOpen?.flag}
      onOk={close}
      onCancel={close}
      closable={false}
      cancelButtonProps={{
        ghost: true,
      }}
      footer={[
        <Button onClick={close} type="ghost">
          Cancel
        </Button>,
        <Button onClick={unarchiveRequest} type="primary" loading={btnLoading}>
          Proceed
        </Button>,
      ]}
    >
      <InfoCircleOutlined />
      <Title level={2}>Unarchive Request</Title>
      {/* <Title level={3}>Issue Resolved</Title> */}
      <p>
        {`Are you sure, you want to send unarchive request to ${isArchiveRequestModalOpen?.name}`}
        .
      </p>
    </Modal>
  );
}
